var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"outlined":"","type":"info","text":""}},[_vm._v(" "+_vm._s(_vm.$t('info.copilotAgentCreationInfo'))+" ")])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }